import { render, staticRenderFns } from "./matchingLawFirm.vue?vue&type=template&id=f9476334&scoped=true"
import script from "./matchingLawFirm.vue?vue&type=script&lang=js"
export * from "./matchingLawFirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9476334",
  null
  
)

export default component.exports